import { z } from "zod"

export const packagingWarehouseInstructionsFormSchema = z.object({
  warehouseInstructions: z.string(),
  bolNotes: z.string(),
})

export type PackagingWarehouseInstructionsFormValues = z.infer<typeof packagingWarehouseInstructionsFormSchema>
